import React from 'react'
import Retour from '../components/Retour'

function Blood() {
  return (
    <div>
         <div>
         <div>
        <div>
    <div style={{textAlign:"center", display:"flex", justifyContent: "center", alignItems: "center"}}>
    <p style={{fontSize:"50px", marginTop: "30px",width:"90%", fontFamily: "Risque, cursive", color: "red"}}>Après un divorce compliqué, Jesse emménage avec sa fille et son jeune fils Owen dans une vieille ferme. Peu de temps après, Owen est mordu violemment par un chien. À l’hôpital, il se réveille avec une étrange soif de sang. Sa mère fera tout pour lui en procurer et le maintenir en vie.</p>
    </div>
    <div style={{textAlign:"center"}}> <Retour /></div>
    </div>
    </div>
    </div>
    </div>
  )
}

export default Blood